var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1861 0.493111L5.50045 5.06061L0.814828 0.493111C0.731111 0.41134 0.618728 0.365561 0.501703 0.365561C0.384677 0.365561 0.272295 0.41134 0.188578 0.493111C0.148042 0.532828 0.115839 0.580233 0.093855 0.632551C0.0718706 0.684869 0.0605469 0.741049 0.0605469 0.797798C0.0605469 0.854548 0.0718706 0.910727 0.093855 0.963045C0.115839 1.01536 0.148042 1.06277 0.188578 1.10249L5.17327 5.96248C5.2608 6.04781 5.37821 6.09556 5.50045 6.09556C5.6227 6.09556 5.7401 6.04781 5.82764 5.96248L10.8123 1.10342C10.8532 1.06368 10.8856 1.01616 10.9078 0.963663C10.9299 0.911172 10.9413 0.854774 10.9413 0.797798C10.9413 0.740823 10.9299 0.684425 10.9078 0.631933C10.8856 0.579441 10.8532 0.53192 10.8123 0.492173C10.7286 0.410402 10.6162 0.364624 10.4992 0.364624C10.3822 0.364624 10.2698 0.410402 10.1861 0.492173V0.493111Z",
    fill: "#0B0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.fdf66259b30f4dcc26da9454c3e93f37.svg";
export { ForwardRef as ReactComponent };